import { mediaUrl } from '../../../api/contentApi';
import { useMedia } from '../MediaContext';

export default function ImageBlock({ block }) {
  const media = useMedia(block.mediaId);
  const src = mediaUrl(media);
  const alt = block.decorative ? '' : block.alt || media?.altText || '';
  const align = ['left', 'right', 'center'].includes(block.alignment) ? block.alignment : 'center';

  return (
    <figure className={`content-image align-${align}`}>
      {src ? (
        <img src={src} alt={alt} width={media.width || undefined} height={media.height || undefined} loading="lazy" />
      ) : (
        <div className="image-missing" role="img" aria-label={alt || 'Image unavailable'}>
          Image unavailable
        </div>
      )}
      {block.caption && <figcaption>{block.caption}</figcaption>}
    </figure>
  );
}
